import React from "react";

export default function Privacy() {
  return (
    <article className="mx-auto max-w-3xl py-6 text-gray-700 dark:text-gray-200">
      <header className="mb-10 border-b border-gray-200 pb-6 dark:border-gray-700">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
          Effective date: 15 September 2026
        </p>
      </header>

      <div className="space-y-8 text-base leading-7">
        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Our commitment to your privacy
          </h2>
          <p>
            SEFF MachineWorks respects your privacy. We do not collect, use, or
            share your personal information unless you choose to provide it and
            give us permission to use it for a specific purpose.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Information you provide
          </h2>
          <p>
            You may choose to provide information when you contact us, request a
            quote, place an order, or otherwise communicate with us. We use that
            information only for the purpose you agreed to, such as responding
            to your enquiry or completing your request.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Sharing your information
          </h2>
          <p>
            We do not sell, rent, trade, or disclose your personal information
            to anyone else without your permission. If sharing information is
            needed to fulfil your request, we will explain why and ask for your
            permission first.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Your choices
          </h2>
          <p>
            You can ask what personal information you have provided to us, ask
            us to correct it, or withdraw your permission and request that we
            delete it. We will honour your request wherever reasonably possible.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Changes to this policy
          </h2>
          <p>
            If our privacy practices change, we will update this page and its
            effective date. We will not apply a new use of your personal
            information without your permission.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-white">
            Contact us
          </h2>
          <p>
            If you have a question or request about your privacy, please contact
            us through our contact page.
          </p>
        </section>
      </div>
    </article>
  );
}
